import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VEHICLE_SELECT_MODES } from 'site-modules/shared/constants/price-checker';

function ModeSelectUI({ activeMode, onModeChange }) {
  return (
    <div className="select-mode d-flex align-items-center mb-2">
      <div className="heading-6">Check price by</div>
      <ul className="list-unstyled text-nowrap text-start mb-0">
        {VEHICLE_SELECT_MODES.map(({ key, label }) => (
          <li key={key} className="ps-2_5 d-inline-block">
            <button
              className={classnames('select-mode-btn d-inline-block py-0 px-0_25 bg-white', {
                active: key === activeMode,
              })}
              data-value={key}
              data-tracking-id="pc_mode_select"
              onClick={onModeChange}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

ModeSelectUI.propTypes = {
  activeMode: PropTypes.string.isRequired,
  onModeChange: PropTypes.func.isRequired,
};

export const ModeSelect = React.memo(ModeSelectUI);
